/* global $:true */
import plugin from '../../lib/plugin';
import { onAvailable } from "../../lib/selectors";

const ELEMENT_SELECTOR = '[data-collapsible]';
const PLUGIN_NAME = 'collapsible';

export function exec() {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		System.import(
			/* webpackChunkName: "plugin--collapsible" */ "./collapsible-v1.1.0"
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/collapsible/index.js